import type { AssetKind } from '@shared/types';

export function inferAssetKind(fileName: string, mimeType: string | null): AssetKind {
  const lowerName = fileName.toLowerCase();
  const extension = lowerName.includes('.') ? lowerName.slice(lowerName.lastIndexOf('.') + 1) : '';

  if (mimeType?.startsWith('image/')) {
    return extension === 'svg' ? 'icon' : 'image';
  }

  if (extension === 'svg') {
    return 'icon';
  }

  if (extension === 'pdf') {
    return 'pdf';
  }

  if (['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'avif'].includes(extension)) {
    return 'image';
  }

  return 'document';
}

export function sanitizeFileName(fileName: string): string {
  const normalized = fileName.replace(/\\/g, '/');
  const baseName = normalized.includes('/') ? normalized.slice(normalized.lastIndexOf('/') + 1) : normalized;
  const trimmed = baseName.trim() || 'file';

  return trimmed.replace(/[<>:"/\\|?*\u0000-\u001F]/g, '_');
}

